import React, {Component} from 'react';
import {connect} from 'react-redux'
import {Flex, FlexItem, Mask} from 'react-weui'
import {renderMoneyHideDecimal} from '../../utils'
import {getTimestamp, showBigAvatar} from '../../utils'


import '../../styles/classroom/ClassroomReward.css'
import reward_head from '../../images/reward_head.png'


class ClassroomReward extends Component {
	hide(){
		this.props.dispatch({
			type: 'CLASSROOM_HIDE_REWARD'
		})
	}

	makeReward(fee){
		const {reward, dispatch, lecture} = this.props
		const account = reward.account

				const {timestampDelta} = this.props
				let timestamp = getTimestamp(timestampDelta)
        dispatch({
        	type: 'PAY_REWARD', 
        	payload: {
        		params: {
		            product:'reward',
		            target: account.id,
		            fee: fee ,
		            lecture_id: lecture.id,
								ts: timestamp,
        		},
        		success: () => {
        			this.hide()
        		}
	        }
	    })
	}

	render(){
		const {reward, options} = this.props
		if(!reward.show)
			return null
		const account = reward.account

		return <div className="classroom-reward">
			<Mask onClick={this.hide.bind(this)} />
			<div className="reward-panel" style={{backgroundImage: `url('${reward_head}')`}}>
				<div className="avatar">
					<img src={account.avatar_url} alt="" onClick={e => showBigAvatar(account.avatar_url)} />
				</div>
				<div className="nickname">
					{account.nickname}
				</div>
				<div className="tips">
					赞赏是一种美德
				</div>
				<div className="rewards">
                    { [[0,1,2], [3,4,5]].map( (l, r) => (
                        <Flex key={r}>
                            {l.map( (v, i) => (
                            <FlexItem key={i} onClick={e=>this.makeReward(options.rewards[v])}>
                                <span className="number">{renderMoneyHideDecimal(options.rewards[v])}</span>
                                元
                            </FlexItem>
                            ))}
                        </Flex>
                    ) )}
				</div>
			</div>
		</div>
	}
}


export default connect((state) => ({
	reward: state.classroom.reward,
	options: state.classroom.options,
	lecture: state.classroom.lecture,
  timestampDelta: state.classroom.timestampDelta,
}))(ClassroomReward)




// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomReward.js